<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-family">
        <div class="modal-header">
          <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
            กรุณาแนบหลักฐาน
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="ClearFile()"
          ></button>
        </div>
        <div class="modal-body fw-normal fs-5">
          <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงรายการข้อมูลดังนี้</div>
          <div class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1" style="width: 25px; border-radius: 50%; cursor: pointer"/>
            <label v-for="(header, index) in this.$store.state.DetailModal" :key="index">{{ header.HEADER }}</label>
          </div>
          <div>
            <label>กรุณากด</label
            ><label class="blue-1 ps-1 pe-1">"แนบไฟล์"</label
            ><label>เพื่อแนบหลักฐานการเปลี่ยนแปลงดังต่อไปนี้</label>
          </div>
          <div class="ps-2">
            <ul>
              <div v-for="(detail, index) in this.$store.state.DetailModal" :key="index">
                <li class="ps-2 blue-1" v-for="(description, id) in detail.DESCRIPTION" :key="id">{{ description }}</li>
              </div>
            </ul>
          </div>
          <div>
            <label
              >(ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน 4 MB)</label
            >
          </div>

          <div class="shadow-none p-3 mb-1 bg-light rounded" v-for="(item, index) in this.$store.state.DetailModal" :key="index">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ บันทึกขอลาออกผ่านความเห็นชอบจากหน่วยต้นสังกัดตรง</label>
              <button type="button" class="border-0 bg-light" @click="FileImport($event, item.SUBJOB, index)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" :key="index" ref="uploader" style="display: none" @change="onFileChange($event, item.SUBJOB)"/>
            </div>
            <div v-if="this.UploadFile != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                <!-- {{ File[index].name }} -->
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFile()"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary fs-5" data-bs-dismiss="modal" @click="ClearFile()">
            แก้ไข
          </button>
          <button type="button" class="btn btn-primary fs-5" data-bs-dismiss="modal" @click="CheckEnter(this.$store.state.PassSuJob)">
            ส่งข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'ModalAddFile',
  data() {
    return {
      UploadFile: null,
      File: [],
      data: '',
      SETFILE: false,
    };
  },
  mounted() { },
  methods: {
    FileImport(e, SUBJOB, index) {
      this.$refs.uploader[index].click(SUBJOB);
    },    
    forResolve(e) { 
       const reader = new FileReader();
      // reader.onload = () => {
      //   this.$store.state.base64 = reader.result.replace("data:", "").replace(/^.+,/, "");
      // };
      reader.readAsDataURL(this.UploadFile);
       this.$store.state.base64 = reader.result?.replace("data:", "")?.replace(/^.+,/, "");
       return this.$store.state.base64;
    },
    async onFileChange(e, SUBJOB) { 
      this.SETFILE = false;

      for (var key in this.$store.state.EditAgentInfo) {
        var obj = this.$store.state.EditAgentInfo[key];
        var hasVal = Object.values(obj).includes(SUBJOB);

        if(hasVal) {
          this.SETFILE = true;
        }
      }

      if(this.SETFILE) { 
        
      }
      else {
        let FILE_TYPE = '';

        let files = e.target.files || e.dataTransfer.files;
        if (files[0].size > 1024 * 1024 * 4) {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</lable>',
          });
        }
        else if (!this.ValidateFileType(files[0].type)) {
          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</lable>',
          });
        }
        else {
          this.UploadFile = files[0];
          if (this.UploadFile != undefined || this.UploadFile != null) {
            this.UploadFile = files[0];
          if (this.UploadFile != undefined || this.UploadFile != null) {
            let A = await this.GetBase64();
            // const reader = new FileReader();
            let B = await this.forResolve(e);
            // reader.readAsDataURL(this.UploadFile);
            // FILE_TYPE = this.UploadFile.type;
            this.File.push(this.UploadFile);
          }



            //await this.GetBase64();


            // const reader = new FileReader();
            // reader.onload = (e) => {
            //   this.$store.state.base64 = reader.result.replace("data:", "").replace(/^.+,/, "");
            // };
            // reader.readAsDataURL(this.UploadFile);

            // FILE_TYPE = this.UploadFile.type;
            // this.File.push(this.UploadFile);
          }
        }

        for (var key in this.$store.state) { 
        var obj = this.$store.state[key];
          if(obj.SUBJOB == SUBJOB) {
            obj.FILE.FILE = this.$store.state.base64;
            obj.FILE.FILE_TYPE = FILE_TYPE;
          }
        }
      }
    },
    ClearFile() {

    },
    DelectFile() {

    },
    CheckEnter(SUBJOB) {


      // if(this.SETFILE) {

      // }
      // else {
      //   for (var key in this.$store.state) { 
      //   var obj = this.$store.state[key];
      //     if(obj.SUBJOB == SUBJOB) {
      //       this.data = obj;
      //     }
      //   }
      // }


      // this.$store.commit('Submit', SUBJOB);
    },
    GetBase64() { 
      const reader = new FileReader();
      reader.onload = () => {
        this.$store.state.base64 = reader.result.replace("data:", "").replace(/^.+,/, "");
      };
      reader.readAsDataURL(this.UploadFile);
    },
    ValidateFileType(Type) {
      if(Type !== "image/png" && Type !== "image/jpeg" && Type !== "application/pdf" && Type !== "image/jpg") {
        this.ClearFile();
        return false;
      }
      else {
        return true;
      }
    }
  },
}
</script>

<style scoped>
</style>